import { useState } from "react";
// mui components
import { Box, Switch } from "@mui/material";
//axios
import EnhancedAxios from "../../api/EnhancedAxios";
// redux hooks
import { useSelector } from "react-redux";
// alerts
import { successAlert, errorAlert } from "../../utils/alerts";

const TemporarilyHoldToggler = ({ id, is_rejected, putApiUrl }) => {
    const [value, setValue] = useState(!is_rejected);
    const userToken = useSelector((state) => state.userToken);
    // const userData = useSelector(state => state.userData);

    const handleChange = (e) => {
        let formData = new FormData();
        formData.append("is_rejected", !e.target.checked);
        EnhancedAxios("multipart/form-data", userToken)
            .put(putApiUrl, formData)
            .then((response) => {
                const alertMsg =
                    response.data.is_rejected === true
                        ? "المستخدم الان مرفوض "
                        : "المستخدم الان غير مرفوض ";
                successAlert(alertMsg);
                setValue(!response.data.is_rejected);
            })
            .catch((error) => {
                errorAlert(error);
            });
    };

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
            }}
        >
            <Switch
                checked={value}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
                size="small"
            />
        </Box>
    );
};

export default TemporarilyHoldToggler;
